import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/lib/theme";

export default function ThemeToggle({ compact = false, className = "" }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";
  const label = isDark ? "Passer en mode clair" : "Passer en mode sombre";
  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      data-testid="theme-toggle"
      className={`inline-flex items-center justify-center ${compact ? "w-8 h-8" : "px-3 py-1.5 gap-1.5"} rounded-md border border-white/10 text-zinc-400 hover:text-white hover:border-white/20 transition-colors ${className}`}
    >
      {isDark
        ? <Sun className="w-3.5 h-3.5" data-testid="theme-icon-sun" />
        : <Moon className="w-3.5 h-3.5" data-testid="theme-icon-moon" />}
      {!compact && <span className="text-xs">{isDark ? "Clair" : "Sombre"}</span>}
    </button>
  );
}
